export default function () {
    if (typeof window.requestIdleCallback === 'undefined') {
        window.requestIdleCallback =
            window.requestIdleCallback ||
            function (cb) {
                const start = Date.now();
                return setTimeout(function () {
                    cb({
                        didTimeout: false,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - start));
                        }
                    });
                }, 1);
            }

        window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (id) {
                clearTimeout(id);
            }
    }

    if (typeof window.CustomEvent !== "function" || window.navigator.userAgent.match(/MSIE|Trident/) !== null) {
        import(/* webpackChunkName: "Polyfill" */ './Polyfill');
    }
}
